<style lang="less" scoped>
  @import './user.less';
</style>
<template>
  <div>
    <page-table ref="pageTable" :loading="tableLoading" :columns="tableColumns" :page-total="pageTotal" :table-data="tableData" highlight-row @btnHandler="btnHandler" @fetchData="fetchData">
      <template slot="searchForm">
        <FormItem><Input v-model="params.keyword" style="width: 200px" placeholder="输入用户名 或 姓名" /></FormItem>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <Tooltip content="详情" placement="top" transfer>
          <Button type="primary" size="small" icon="md-eye" style="margin-right: 5px" @click="btnHandler('details', row)" />
        </Tooltip>
        <Tooltip v-if="!row.send_date" content="编辑" placement="top" transfer>
          <Button type="info" size="small" icon="md-create" style="margin-right: 5px" @click="btnHandler('edit', row)" />
        </Tooltip>
        <Tooltip v-if="!row.send_date && $store.state.userInfo" content="删除" placement="top" transfer>
          <Button type="warning" size="small" icon="md-trash" style="margin-right: 5px" @click="btnHandler('delete', row)" />
        </Tooltip>
      </template>
    </page-table>
  </div>
</template>
<script>
import { getUserIndex, add, edit } from '@/api/user'
import { getGroups } from '@/api/auth'
import pageTable from '../../components/pageTable/index'

export default {
  name: 'system_user',
  components: { pageTable },
  data () {
    return {
      params: {
        keyword: ''
      },
      tableLoading: false,
      tableColumns: [
        { title: '操作', slot: 'action', width: 100, align: 'center', fixed: 'left' },
        { title: '用户账号', key: 'username', width: 120 },
        { title: '用户姓名', key: 'realname', width: 120 },
        { title: '商户', key: 'merchants', minWidth: 150, slot: 'merchants' },
        { title: '用户类型', key: 'user_type', width: 100, slot: 'user_type' },
        { title: '手机', key: 'mobile', width: 120 },
        { title: '状态', key: 'status', width: 100, slot: 'status' }
      ],
      tableData: [],
      pageTotal: 0
    }
  },
  created () {
  },
  methods: {
    btnHandler () {
      console.log(null)
    },
    fetchData (page) {
      this.tableLoading = true
      getUserIndex({ ...page, ...this.params }).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    alertAdd () {
      let vm = this
      getGroups().then(response => {
        vm.groupList = response.data.data.list
      })
      this.modalSetting.show = true
    },
    submit () {
      let vm = this
      this.$refs['myForm'].validate((valid) => {
        if (valid) {
          vm.modalSetting.loading = true
          if (vm.formItem.id === 0) {
            add(vm.formItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.cancel()
            }).catch(() => {
              vm.modalSetting.loading = false
            })
          } else {
            edit(vm.formItem).then(response => {
              vm.$Message.success(response.data.msg)
              vm.getList()
              vm.cancel()
            }).catch(() => {
              vm.modalSetting.loading = false
            })
          }
        }
      })
    },
    cancel () {
      this.modalSetting.show = false
    },
    doCancel (data) {
      if (!data) {
        this.formItem.id = 0
        this.$refs['myForm'].resetFields()
        this.modalSetting.loading = false
        this.modalSetting.index = 0
      }
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {
      let vm = this
      let params = {
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        type: vm.searchConf.type,
        keywords: vm.searchConf.keywords,
        status: vm.searchConf.status
      }
      vm.listLoading = true
      getUserIndex(params).then(({ data }) => {
        vm.tableData = data.data
        vm.tableShow.listCount = data.total
        vm.listLoading = false
      })
    }
  }
}
</script>
